import { Component, OnInit } from '@angular/core';
import { FeatureComponent } from '../wordpress-resources/feature/feature.component';
import { FullListComponent } from '../wordpress-resources/full-list/full-list.component';
import { WordpressRetrieveService } from '../wordpress-retrieve.service';

@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.css']
})

export class FeedComponent implements OnInit {
  allPosts : any;
  
  constructor(private service:WordpressRetrieveService) {
    this.allPosts = [];
  }
  public ngOnInit(){
    this.service.getAllPosts().subscribe((result)=>{
      //console.log(result);
      this.allPosts = result;
    });
  }
}

